import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { RoundedTextButton } from "$/game/prefabs/ui/RoundedTextButton.ts";
import { sendPreparedMessage } from "$/common/telegram-utils.ts";

export class CurrencyShopScene extends BasicScene {
  constructor() {
    super("CurrencyShopScene");
  }

  create(): void {
    // this.soundManager.playMusic(this.keys.assets.sounds.music.home);

    // Add background with color from TUNER_TWA_CONFIG
    const backgroundColor = this.global.TUNER_TWA_CONFIG.palette.background;
    this.add.rectangle(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      this.cameras.main.width,
      this.cameras.main.height,
      backgroundColor,
    ).setDepth(-1);

    // 1) Add "Получить яйца" text
    const titleText = this.add.text(
      this.cameras.main.width / 2,
      56,
      this.keys.strings.currencyShopScene.getEggs,
      {
        fontFamily: "Phantom-Muff",
        fontSize: "40px",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      },
    );
    titleText.setOrigin(0.5, 0); // Center horizontally, align top

    // 2) Add RoundedTextButton with "Пригласить" text
    const inviteButton = new RoundedTextButton(
      this,
      480,
      176,
      this.keys.strings.currencyShopScene.invite,
      323,
      72,
      20,
      this.global.TUNER_TWA_CONFIG.palette.success,
      this.global.TUNER_TWA_CONFIG.palette.success + 0x100000,
      {
        fontSize: "40px",
        fontStyle: "normal",
        fontFamily: "Phantom-Muff",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      },
    );

    inviteButton.on("pointerdown", async () => {
      try {
        this.overlay.show("LoadingOverlay", false);
        const resp = await this.api.user.share();

        if (resp.result?.id) {
          sendPreparedMessage(resp.result.id);
        } else {
          console.error("No message ID received from API", resp);
        }
      } catch (error) {
        console.error("Error creating share message:", error);
      }

      this.overlay.close("LoadingOverlay");
    });

    // 3) Add eggUi element
    const eggUi = this.add.image(
      91,
      176,
      this.atlas,
      this.keys.assets.sprites.ui.crystalUi,
    );

    // 4) Add "100" text
    const countShareText = this.add.text(
      91 + 40,
      176,
      "20",
      {
        fontFamily: "Phantom-Muff",
        fontSize: "40px",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      },
    );
    countShareText.setOrigin(0, 0.5); // Align left and center vertically

    const motivationText = this.add.text(
      91,
      256,
      this.keys.strings.currencyShopScene.motivationText,
      {
        fontFamily: "Phantom-Muff",
        fontSize: "24px",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        align: "center",
      },
    );
    // motivationText.setOrigin(0, 0);

    // Add items for purchase from TUNER_COINS_STORE_CONFIG.items
    const items = this.global.TUNER_COINS_STORE_CONFIG.items;
    const startY = 400; // Starting Y position for items
    const itemSpacing = 85; // Vertical spacing between items

    items.forEach((item, index) => {
      const yPos = startY + index * itemSpacing;

      const eggUi = this.add.image(
        91,
        yPos,
        this.atlas,
        this.keys.assets.sprites.ui.crystalUi,
      );

      // Add item amount text
      const countText = this.add.text(
        91 + 40,
        yPos,
        item.itemAmount.toString(),
        {
          fontFamily: "Phantom-Muff",
          fontSize: "40px",
          color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        },
      );
      countText.setOrigin(0, 0.5); // Align left and center vertically

      // Add RoundedTextButton with price
      const priceButton = new RoundedTextButton(
        this,
        480,
        yPos,
        item.prices[0].amount.toString(),
        323,
        72,
        20,
        this.global.TUNER_TWA_CONFIG.palette.primary,
        this.global.TUNER_TWA_CONFIG.palette.primary + 0x100000,
        {
          fontSize: "40px",
          fontStyle: "normal",
          fontFamily: "Phantom-Muff",
          color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        },
      ).on("pointerdown", () => {
        this.soundManager.playSound(this.keys.assets.sounds.penClick, {
          volume: 0.25,
        });
        this.handlePurchase(item.code);
      });

      // Add star UI image to the right of the text inside the button
      const starUi = this.add.image(
        60,
        0,
        this.atlas,
        this.keys.assets.sprites.ui.starUi,
      );
      starUi.setScale(0.1); // Scale the star image to fit nicely
      // Make sure the star is part of the button by adding it to the button's container
      priceButton.add(starUi);
    });

    // Add "Наш канал" button
    const channelButton = new RoundedTextButton(
      this,
      this.cameras.main.width / 2, // Center horizontally
      855, // Positioned above the support button
      this.keys.strings.currencyShopScene.ourChannelText,
      538, // Width: 538px
      118, // Height: 118px
      20, // Radius
      this.global.TUNER_TWA_CONFIG.palette.success, // Default color
      this.global.TUNER_TWA_CONFIG.palette.success + 0x100000, // Hover color
      {
        fontSize: "40px",
        fontStyle: "normal",
        fontFamily: "Phantom-Muff",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        align: "center",
      },
    );

    // Add click handler for the channel button
    channelButton.on("pointerdown", async () => {
      this.soundManager.playSound(this.keys.assets.sounds.penClick, {
        volume: 0.25,
      });

      try {
        // Open the Telegram channel link using a method that works across all platforms
        if (this.global.TWA) {
          // For iOS compatibility, we use the location.href approach which is more reliable
          // than window.open in Telegram Web Apps
          window.location.href = "https://t.me/telegochigame";
        }
      } catch (error) {
        console.error("Error opening channel link:", error);
      }
    });

    const tgUi = this.add.image(
      160,
      0,
      this.atlas,
      this.keys.assets.sprites.ui.tgUi,
    );
    tgUi.setScale(0.1); // Scale the tg image to fit nicely
    // Make sure the star is part of the button by adding it to the button's container
    channelButton.add(tgUi);

    // Add "Поддержать разработчиков ❤️" button
    const supportButton = new RoundedTextButton(
      this,
      this.cameras.main.width / 2, // Center horizontally
      995, // Moved down to accommodate the new button
      this.keys.strings.currencyShopScene.supportText,
      538, // Width: 538px
      118, // Height: 118px
      20, // Radius
      this.global.TUNER_TWA_CONFIG.palette.success, // Default color
      this.global.TUNER_TWA_CONFIG.palette.success + 0x100000, // Hover color
      {
        fontSize: "40px",
        fontStyle: "normal",
        fontFamily: "Phantom-Muff",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
        align: "center",
      },
    );

    // Add click handler for the support button if needed
    supportButton.on("pointerdown", async () => {
      this.soundManager.playSound(this.keys.assets.sounds.penClick, {
        volume: 0.25,
      });

      try {
        // Show loading overlay while making API call
        this.overlay.show("LoadingOverlay", false);

        // Call the user donate endpoint
        await this.api.user.donate();

        // Close loading overlay
        this.overlay.close("LoadingOverlay");

        // Close the application to show the donation interface
        if (this.global.TWA) {
          this.global.TWA.close();
        }
      } catch (error) {
        console.error("Error calling donate API:", error);

        // Close loading overlay if it's still open
        this.overlay.close("LoadingOverlay");

        // Show error message
        const errorMessage = this.keys.strings.currencyShopScene.donateError;
        if (this.global.TWA) {
          this.global.TWA.showAlert(errorMessage);
        } else {
          alert(errorMessage);
        }
      }
    });

    // Back button
    const backButton = new RoundedTextButton(
      this,
      this.cameras.main.width / 2,
      1110, // Moved down to accommodate the new button
      this.keys.strings.currencyShopScene.exit,
      323,
      72,
      20,
      this.global.TUNER_TWA_CONFIG.palette.danger,
      this.global.TUNER_TWA_CONFIG.palette.danger + 0x100000,
      {
        fontSize: "40px",
        fontStyle: "normal",
        fontFamily: "Phantom-Muff",
        color: "#" + this.global.TUNER_TWA_CONFIG.palette.text.toString(16),
      },
    );

    backButton.on("pointerdown", () => {
      this.transition.toScene(
        "PetHomeScene",
        this.keys.strings.sceneTransitions.backToPet,
      );
    });
  }

  private async handlePurchase(code: string) {
    try {
      // Create the invoice using the API module
      this.overlay.show("LoadingOverlay", false);
      const response = await this.api.payment.createInvoice(code);
      this.overlay.close("LoadingOverlay");
      const data = response.data;

      if (data.invoiceLink) {
        // Open the invoice
        if (this.global.TWA) {
          this.global.TWA.openInvoice(
            data.invoiceLink,
            (status: string) => {
              console.log("Invoice status:", status);
              if (status === "paid") {
                console.log("Payment successful!");
                // Show confetti effect on successful purchase
                this.showConfetti();
                // Redirect to main page after successful purchase
                this.time.delayedCall(1500, () => {
                  this.redirectToHome();
                });
              } else if (status === "failed") {
                console.log("Payment failed!");
              } else if (status === "pending") {
                console.log("Payment pending...");
              }
            },
          );
        }
      } else {
        console.error("No invoice link received");
      }
    } catch (error) {
      console.error("Error creating invoice:", error);
      this.overlay.close("LoadingOverlay");
    }
  }

  private showConfetti(): void {
    try {
      const jsConfetti = new (window as any).JSConfetti();
      jsConfetti.addConfetti();
    } catch (error) {
      console.error("Error showing confetti:", error);
    }
  }

  private redirectToHome() {
    this.api.pet.get();
    this.transition.toScene(
      "PetHomeScene",
      this.keys.strings.sceneTransitions.eggsPurchased,
    );
  }
}
